module.exports = __webpack_public_path__ + "static/media/girl-on-computer.c0586a26.jpg";